
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcIntegrationAppBar as ObcIntegrationAppBarElement} from '@oicl/openbridge-webcomponents/dist/integration-systems/integration-app-bar/integration-app-bar.js';
 
 
 

 
 export const ObcIntegrationAppBar = createComponent({
   react: React,
   tagName: 'obc-integration-app-bar',
   elementClass: ObcIntegrationAppBarElement,
   events: {
     
   }
  });
 
 